<template>
  <button class="promo-button" @click="$emit('open-promo')" title="更多精彩内容">
    <svg class="curtain-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 3h18v2H3V3zm0 16h18v2H3v-2z" fill="currentColor"/>
      <path d="M5 7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1V7zm4 0c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1V7zm4 0c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1V7zm4 0c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1V7z" fill="currentColor" opacity="0.6"/>
    </svg>
    <span class="promo-text">更多好题</span>
  </button>
</template>

<script>
export default {
  name: 'PromoButton'
}
</script>

<style src="@/styles/PromoButton.css"></style>
